import styled from 'styled-components';

export const StyledUserActions = styled.div`
	align-items: center;
	display: flex;
	gap: 4px;
	justify-content: flex-start;
`;
